















































const CODES_BADGE = ["overdue", "soon", "broken", "in-maint"];

export default {
    name: "EquipementCard",
    props: {
        equipement: {
            type: Object,
            required: true,
        },
    },
    computed: {
        broken: function () {
            return this.equipement.etat_operationnel === "broken";
        },
        maintenanceCode: function () {
            return this.equipement.maintenance
                ? this.equipement.maintenance.code
                : "";
        },
        maintenanceLabel: function () {
            return this.equipement.maintenance
                ? this.equipement.maintenance.label
                : "";
        },
        showMaintBadge: function () {
            return (
                !this.equipement.archived &&
                CODES_BADGE.indexOf(this.maintenanceCode) !== -1
            );
        },
    },
};
